import React from 'react';
import Swal from 'sweetalert2';

const ConfirmDialog = ({ title, text, confirmText, cancelText, onConfirm, confirmButtonClass = "" }) => {
  const handleClick = () => {
    Swal.fire({
      title: title,
      text: text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        onConfirm();
      }
    });
  };

  return <button onClick={handleClick} className={confirmButtonClass}>{confirmText}</button>;
};

export default ConfirmDialog;
